import { useMutation, UseMutationOptions } from "react-query";

import { sendVerifyCode, createUserFromCheckout } from "../api";
import { useOptInStore } from "../store";
import { WretcherResponse, WretcherError } from "wretch";

export const BREAKPOINT = 480;

export function useSubmitUserInfo(
  options: UseMutationOptions<WretcherResponse, WretcherError>
) {
  // @ts-ignore
  return useMutation(sendVerifyCode, options);
}

export function useConfirmCode(options: UseMutationOptions) {
  // @ts-ignore
  return useMutation(createUserFromCheckout, options);
}

export function useContainerSize() {
  const width = useOptInStore((state) => state.container.width);
  return width < BREAKPOINT ? "mobile" : "desktop";
}
